(function () {
  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency || window.Shopify?.currency?.active || 'USD' }).format(Number(cents || 0) / 100);

  const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[ch]));

  async function fetchCart() {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Could not load cart');
    return response.json();
  }

  async function renderCart(open) {
    const cart = await fetchCart();
    document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = String(cart.item_count || 0); });
    const body = document.querySelector('[data-cart-body]');
    if (body) {
      if (!cart.items.length) body.innerHTML = '<p>Your cart is empty.</p><div class="emy-drawer-actions"><a href="/collections/all">Continue shopping</a></div>';
      else body.innerHTML = cart.items.map((item) => `<div class="emy-drawer-line"><img src="${escapeHtml(item.image || '')}" alt=""><div><a href="${escapeHtml(item.url)}"><strong>${escapeHtml(item.product_title)}</strong></a><small>${escapeHtml(item.variant_title || '')}</small><p>${item.quantity} × ${money(item.final_price, cart.currency)}</p></div></div>`).join('') + `<div class="emy-drawer-actions"><strong>Total: ${money(cart.total_price, cart.currency)}</strong><a href="/cart">View cart</a><a class="checkout" href="/checkout">Checkout</a></div>`;
    }
    if (open) {
      document.body.classList.add('drawer-open');
      document.querySelector('[data-cart-drawer]')?.classList.add('open');
      document.querySelector('[data-cart-drawer]')?.setAttribute('aria-hidden', 'false');
      const backdrop = document.querySelector('.emy-cart-backdrop');
      if (backdrop) backdrop.hidden = false;
    }
  }

  function closeCart() {
    document.body.classList.remove('drawer-open');
    document.querySelector('[data-cart-drawer]')?.classList.remove('open');
    document.querySelector('[data-cart-drawer]')?.setAttribute('aria-hidden', 'true');
    const backdrop = document.querySelector('.emy-cart-backdrop');
    if (backdrop) backdrop.hidden = true;
  }

  function initCart() {
    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-cart-open]')) renderCart(true).catch(() => { window.location.href = '/cart'; });
      if (event.target.closest('[data-cart-close]')) closeCart();
    });
    renderCart(false).catch(() => {});
  }

  function initGallery(root) {
    const rail = root.querySelector('.emy-gallery-main');
    const images = [...root.querySelectorAll('.emy-gallery-image')];
    const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
    const dots = [...root.querySelectorAll('.srcp-gallery-dots i')];
    if (thumbs[0]) thumbs[0].classList.add('active');
    thumbs.forEach((button, index) => button.addEventListener('click', () => {
      images[index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      thumbs.forEach((item) => item.classList.remove('active'));
      button.classList.add('active');
      dots.forEach((item, position) => item.classList.toggle('active', position === index));
    }));
    rail?.addEventListener('scroll', () => {
      if (!rail.clientWidth) return;
      const index = Math.round(rail.scrollLeft / rail.clientWidth);
      thumbs.forEach((item, position) => item.classList.toggle('active', position === index));
      dots.forEach((item, position) => item.classList.toggle('active', position === index));
    }, { passive: true });
  }

  function initProduct(root) {
    let product;
    try { product = JSON.parse(root.getAttribute('data-product-json')); } catch (_) { return; }
    const form = root.querySelector('[data-product-form]');
    const idInput = form?.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-product-price]');
    const radios = [...root.querySelectorAll('.emy-option-values input')];
    const selects = [...root.querySelectorAll('[data-product-option]')];
    const selectVariant = () => {
      const options = [...root.querySelectorAll('fieldset[data-option-index]')].map((field) => field.querySelector('input:checked')?.value || field.querySelector('[data-product-option]')?.value || '');
      const variant = product.variants.find((item) => item.options.every((value, index) => value === options[index]));
      root.querySelectorAll('fieldset[data-option-index]').forEach((field) => { const label = field.querySelector('[data-option-value]'); if (label) label.textContent = field.querySelector('input:checked')?.value || field.querySelector('[data-product-option]')?.value || ''; });
      if (!variant || !idInput) return;
      idInput.value = variant.id;
      const button = form.querySelector('.emy-add');
      button.disabled = !variant.available;
      button.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (price) price.innerHTML = `<span class="sale">${money(variant.price)}</span>${variant.compare_at_price > variant.price ? `<s>${money(variant.compare_at_price)}</s><span class="save">Save ${money(variant.compare_at_price - variant.price)}</span>` : ''}`;
    };
    radios.forEach((radio) => radio.addEventListener('change', selectVariant));
    selects.forEach((select) => select.addEventListener('change', selectVariant));
    root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      const input = form?.querySelector('input[name="quantity"]');
      if (input) input.value = String(Math.max(1, Number(input.value || 1) - 1));
    });
    root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      const input = form?.querySelector('input[name="quantity"]');
      if (input) input.value = String(Math.max(1, Number(input.value || 1) + 1));
    });
    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('.emy-add');
      button.disabled = true;
      button.textContent = 'Adding…';
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error(await response.text());
        document.dispatchEvent(new CustomEvent('emyerre:add_to_cart_succeeded'));
        await renderCart(true);
      } catch (error) {
        alert('This item could not be added. Please try again.');
      } finally {
        selectVariant();
      }
    });
    initGallery(root);
  }

  function initDeferredVideos() {
    const activate = (video) => {
      const source = video.querySelector('source[data-src]');
      if (source) { source.src = source.dataset.src; source.removeAttribute('data-src'); video.load(); }
      if (video.dataset.src) { video.src = video.dataset.src; video.removeAttribute('data-src'); }
      video.play().catch(() => {});
    };
    const videos = [...document.querySelectorAll('video[data-src], video source[data-src]')]
      .map((node) => node.tagName === 'VIDEO' ? node : node.parentElement).filter(Boolean);
    if (!('IntersectionObserver' in window)) { videos.forEach(activate); return; }
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) { activate(entry.target); observer.unobserve(entry.target); }
    }), { rootMargin: '300px' });
    videos.forEach((video) => observer.observe(video));
  }

  async function renderHomeProducts() {
    const target = document.querySelector('[data-home-products]');
    const orderNode = document.querySelector('[data-home-product-order]');
    if (!target || !orderNode) return;
    try {
      const order = JSON.parse(orderNode.textContent);
      const response = await fetch('/products.json?limit=250', { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Product feed unavailable');
      const payload = await response.json();
      const byHandle = new Map((payload.products || []).map((product) => [product.handle, product]));
      target.innerHTML = order.map((handle) => byHandle.get(handle)).filter(Boolean).map((product) => {
        const variant = product.variants?.[0] || {};
        const image = product.images?.[0]?.src || '';
        const secondaryImage = product.images?.[1]?.src || '';
        const current = Number(variant.price || 0) * 100;
        const compare = Number(variant.compare_at_price || 0) * 100;
        const badge = compare > current ? `<span class="emy-badge">Save ${money(compare - current)}</span>` : '';
        const secondary = secondaryImage ? `<img class="emy-card-secondary" src="${escapeHtml(secondaryImage)}&width=900" alt="${escapeHtml(product.title)}" loading="lazy">` : '';
        return `<article class="emy-product-card"><a href="/products/${encodeURIComponent(product.handle)}"><span class="emy-product-card-media">${badge}<img class="emy-card-primary" src="${escapeHtml(image)}&width=900" alt="${escapeHtml(product.title)}" loading="lazy">${secondary}</span><h2>${escapeHtml(product.title)}</h2><p><span>${money(current)}</span>${compare > current ? `<s>${money(compare)}</s>` : ''}</p></a></article>`;
      }).join('');
    } catch (error) {
      target.innerHTML = '<p>Products are temporarily unavailable.</p>';
    }
  }

  async function renderOrderedProductGrids() {
    const grids = [...document.querySelectorAll('[data-ordered-product-grid]')];
    if (!grids.length) return;
    try {
      const response = await fetch('/products.json?limit=250', { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Product feed unavailable');
      const payload = await response.json();
      const byHandle = new Map((payload.products || []).map((product) => [product.handle, product]));
      grids.forEach((grid) => {
        const orderNode = grid.nextElementSibling;
        const order = orderNode ? JSON.parse(orderNode.textContent) : [];
        grid.innerHTML = order.map((handle) => byHandle.get(handle)).filter(Boolean).map((product) => {
          const variant = product.variants?.[0] || {};
          const image = product.images?.[0]?.src || '';
          const current = Number(variant.price || 0) * 100;
          const compare = Number(variant.compare_at_price || 0) * 100;
          const badge = compare > current ? `<span class="emy-badge">Save ${money(compare - current)}</span>` : '';
          return `<article class="emy-product-card"><a href="/products/${encodeURIComponent(product.handle)}"><span class="emy-product-card-media">${badge}<img class="emy-card-primary" src="${escapeHtml(image)}&width=900" alt="${escapeHtml(product.title)}" loading="lazy"></span><h2>${escapeHtml(product.title)}</h2><p><span>${money(current)}</span>${compare > current ? `<s>${money(compare)}</s>` : ''}</p></a></article>`;
        }).join('');
      });
    } catch (_) {
      grids.forEach((grid) => { grid.innerHTML = '<p>Products are temporarily unavailable.</p>'; });
    }
  }

  function initMobileMenu() {
    const trigger = document.querySelector('[data-mobile-menu]');
    const menu = document.querySelector('.emy-nav--main');
    if (!trigger || !menu) return;
    trigger.addEventListener('click', () => {
      const open = menu.classList.toggle('mobile-open');
      trigger.setAttribute('aria-expanded', String(open));
    });
  }

  function initNewsletter() {
    const popup = document.querySelector('[data-newsletter]');
    if (!popup || sessionStorage.getItem('emyerre_newsletter_seen')) return;
    window.setTimeout(() => { popup.hidden = false; sessionStorage.setItem('emyerre_newsletter_seen', '1'); }, 5000);
    popup.querySelector('[data-newsletter-close]')?.addEventListener('click', () => { popup.hidden = true; });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.rte').forEach((node) => node.classList.add('prose'));
    document.querySelectorAll('.shopify-policy__title').forEach((node) => node.classList.add('h1'));
    initCart();
    document.querySelectorAll('[data-product-root]').forEach(initProduct);
    renderHomeProducts();
    renderOrderedProductGrids();
    initNewsletter();
    initMobileMenu();
    initDeferredVideos();
  });
})();
